import { render, staticRenderFns } from "./Etc.vue?vue&type=template&id=6afb8c07&scoped=true"
import script from "./Etc.vue?vue&type=script&lang=js"
export * from "./Etc.vue?vue&type=script&lang=js"
import style0 from "./Etc.vue?vue&type=style&index=0&id=6afb8c07&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6afb8c07",
  null
  
)

export default component.exports